import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";

export default function OptimizeTab() {
  const [platforms, setPlatforms] = useState([]);
  const [platform, setPlatform] = useState("etsy");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => { http.get("/platforms").then(r => setPlatforms(r.data)); }, []);

  const submit = async () => {
    if (!title && !description) { toast.error("Paste your current listing"); return; }
    setLoading(true); setResult(null);
    try {
      const r = await http.post("/optimize", {
        title, description, tags: tags.split(",").map(t=>t.trim()).filter(Boolean),
        platform, tone: "professional",
      });
      setResult(r.data);
      toast.success("Optimized · -1 credit");
    } catch (e) { toast.error(e?.response?.data?.detail || "Optimize failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-5">
      <div className="tt-card p-6">
        <h1 className="text-3xl font-black h-tight">Optimize an existing listing</h1>
        <p className="text-sm text-zinc-500 mt-1">Paste your current title, description, tags. Get a higher-ranking rewrite plus a before/after score.</p>
        <div className="mt-5 grid gap-3">
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold mb-1">Platform</div>
            <select data-testid="opt-platform-select" className="input" value={platform} onChange={e=>setPlatform(e.target.value)}>
              {platforms.map(p => <option key={p.key} value={p.key}>{p.name}</option>)}
            </select>
          </div>
          <input data-testid="opt-title" className="input" placeholder="Current title" value={title} onChange={e=>setTitle(e.target.value)} />
          <textarea data-testid="opt-desc" className="input min-h-[110px]" placeholder="Current description" value={description} onChange={e=>setDescription(e.target.value)} />
          <input data-testid="opt-tags" className="input" placeholder="Current tags (comma separated)" value={tags} onChange={e=>setTags(e.target.value)} />
          <button data-testid="optimize-btn" disabled={loading} onClick={submit} className="btn-primary self-end">
            {loading ? "Optimizing…" : "Rewrite for max SEO"}
          </button>
        </div>
      </div>
      {result && (
        <div className="grid md:grid-cols-2 gap-5 tt-fade" data-testid="opt-result">
          <div className="tt-card p-6">
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold">Before</div>
            <div className="mt-2 text-5xl font-black h-tight mono">{result.before?.score ?? "-"}</div>
            <div className="text-xs text-zinc-500">Your original</div>
          </div>
          <div className="tt-card p-6 border-2 border-[#09090B]">
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold">After</div>
            <div className="mt-2 text-5xl font-black h-tight mono">{result.after?.score ?? "-"}</div>
            <div className="mt-3 font-bold">{result.after?.titleSeo}</div>
            <div className="mt-1 text-sm text-zinc-700 whitespace-pre-wrap">{result.after?.descriptionShort}</div>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {(result.after?.tags || []).map((t,i)=><span key={i} className="text-xs bg-zinc-100 border border-zinc-200 rounded-full px-2 py-0.5">{t}</span>)}
            </div>
          </div>
          {!!(result.changes && result.changes.length) && (
            <div className="tt-card p-6 md:col-span-2">
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold">Changes made</div>
              <ul className="mt-2 list-disc list-inside space-y-1 text-sm">
                {result.changes.map((c,i)=><li key={i}>{c}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
